import { motion } from "framer-motion";

export default function Tagline() {
  return (
    <div className="w-full flex flex-col items-center justify-center py-10 bg-[#0F172A] text-white relative">
      {/* Stylish Divider */}
      <div className="w-20 h-1 bg-[#C9A227] rounded-full mb-4"></div>

      {/* Animated Tagline */}
      <motion.h3
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        className="text-2xl md:text-3xl font-bold text-center leading-relaxed max-w-2xl px-6"
      >
        <span className="bg-gradient-to-r from-[#C9A227] to-[#FFD700] bg-clip-text text-transparent">
          No matter how big or small the case, 
        </span>
        <br />
        every client receives the{" "}
        <span className="text-[#C9A227] ">
          <span className=" font-bold " >best</span> service possible.
        </span>
      </motion.h3>

      {/* Stylish Divider */}
      <div className="w-20 h-1 bg-[#C9A227] rounded-full mt-4"></div>
    </div>
  );
}
